import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useForm, SchemaFields } from 'informed';
import { adapter } from './TdsAdapter.js';
import { FormLayout, Button } from '@tesla/design-system-react';

var _excluded = ["children"];
var FormChildren = function FormChildren(_ref) {
  var children = _ref.children,
    formApi = _ref.formApi;
  if (typeof children === 'function') {
    return children({
      formApi: formApi
    });
  }
  if (children == null) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormLayout, null, /*#__PURE__*/React.createElement(SchemaFields, null), /*#__PURE__*/React.createElement(Button, {
      variant: "primary"
    }, "Submit")));
  }
  return children;
};
var Form = function Form(_ref2) {
  var children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var _useForm = useForm(_objectSpread2(_objectSpread2({}, rest), {}, {
      adapter: adapter
    })),
    formApi = _useForm.formApi,
    formController = _useForm.formController,
    render = _useForm.render,
    userProps = _useForm.userProps;

  /* --- Render Content --- */
  return render( /*#__PURE__*/React.createElement("form", _extends({}, userProps, {
    noValidate: true,
    onReset: formController.reset,
    onSubmit: formController.submitForm,
    onKeyDown: formController.keyDown
  }), /*#__PURE__*/React.createElement(FormChildren, {
    formApi: formApi
  }, children)));
};

export { Form };
